import { MarketBanner } from '@market/react';
import type { BannerProps } from '../components/page/product-page-header/ProductPageHeader';

export const buildMarketBanner = (banner: BannerProps) => (
  <MarketBanner
    key={banner.key}
    data-testid="shim-market-banner"
    variant={banner.variant}
  >
    <span slot="title">{banner.title}</span>
    {banner.descriptionHtml &&
    // eslint-disable-next-line square/no-dangerously-set-inner-html
    <span dangerouslySetInnerHTML={{ __html: banner.descriptionHtml }} />}
    {banner.description}
    {banner.actions && banner.actions.length > 0
      ? banner.actions.map((action) => (
        action.elementType === 'button'
          ? (
            <button
              key={action.text}
              slot="action"
              onClick={action.onClick}
            >{action.text}</button>
          )
          : (
            <a
              key={action.text}
              target="_blank"
              rel="noopener noreferrer"
              slot="action"
              href={action.href}
            >{action.text}</a>
          )
      ))
      : null}
  </MarketBanner>
);
